import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function ProfileServiceIcon(props: { color?: string; }) {
	const {color = null} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<g id="Icon">
				<g id="vuesax/bulk/user-octagon">
					<g id="user-octagon">
						<path id="Vector" opacity="0.4"
						      d="M28.1075 11.44V20.56C28.1075 22.0533 27.3075 23.44 26.0142 24.2L18.0942 28.7733C16.8009 29.52 15.2009 29.52 13.8942 28.7733L5.97419 24.2C4.68086 23.4533 3.88086 22.0666 3.88086 20.56V11.44C3.88086 9.94667 4.68086 8.55995 5.97419 7.79995L13.8942 3.22663C15.1875 2.47996 16.7875 2.47996 18.0942 3.22663L26.0142 7.79995C27.3075 8.55995 28.1075 9.93334 28.1075 11.44Z"
						      fill={color || 'url(#paint0_linear_2116_2675)'}/>
						<g id="Group">
							<path id="Vector_2"
							      d="M16.0012 16C17.717 16 19.1079 14.6091 19.1079 12.8934C19.1079 11.1776 17.717 9.78674 16.0012 9.78674C14.2854 9.78674 12.8945 11.1776 12.8945 12.8934C12.8945 14.6091 14.2854 16 16.0012 16Z"
							      fill={color || 'url(#paint1_linear_2116_2675)'}/>
							<path id="Vector_3"
							      d="M19.5742 22.2133C20.6542 22.2133 21.2809 21.0134 20.6809 20.12C19.7742 18.7734 18.0142 17.8667 16.0009 17.8667C13.9875 17.8667 12.2275 18.7734 11.3209 20.12C10.7209 21.0134 11.3475 22.2133 12.4275 22.2133H19.5742Z"
							      fill={color || 'url(#paint2_linear_2116_2675)'}/>
						</g>
					</g>
				</g>
			</g>
			<defs>
				<linearGradient id="paint0_linear_2116_2675" x1="27.5905" y1="2.66663" x2="2.70727" y2="3.81082"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
				<linearGradient id="paint1_linear_2116_2675" x1="18.9753" y1="9.78674" x2="12.5964" y2="10.1096"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
				<linearGradient id="paint2_linear_2116_2675" x1="20.7041" y1="17.8667" x2="10.7213" y2="19.0089"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
